<template>
  <div class="ConfInter">
    <div class="titlePage">Reporte Intersemestral</div>
    <va-notification color="danger" v-if="refNoData" class="refNoData">No se encuentran casos en este momento.</va-notification>
    <div class="listData">
      <DataList
        :InfoView="this.DLDataList"
        :HeadTable="this.HDDataList"
        :filterData="this.FilterData"
        v-if="renderComponent1"
      />
    </div>
  </div>
</template>

<script>
import IberoHelpers from '@/store/helpers.js'
import DataList from '@/components/data-tables/DataReportCase.vue'

export default {
  name: 'ReportInter',
  data () {
    return {
      FilterData: [
        {
          ListPrograms: [],
          ListFaculty: [],
        },
      ],
      HDDataList: [
        {
          name: '__slot:caseZoho',
          title: 'Caso ZOHO',
          dataClass: 'text-left',
          width: '10%',
        },
        {
          name: 'Nam_Person',
          title: 'Nombres',
          width: '10%',
        },
        {
          name: 'Last_NamePerson',
          title: 'Apellidos',
          width: '20%',
        },
        {
          name: 'Det_IdentificationName',
          title: 'Tipo de documento',
          width: '20%',
        },
        {
          name: 'Det_IdentificationNumber',
          title: 'Numero de documento',
          width: '20%',
        },
        {
          name: 'Det_BannerID',
          title: 'ID Banner',
          width: '20%',
        },
        {
          name: 'Det_Email_Personal',
          title: 'Correo personal',
          width: '20%',
        },
        {
          name: 'Det_Email_Corporative',
          title: 'Correo institucional',
          width: '20%',
        },
        {
          name: 'Det_Mobile',
          title: 'Celular',
          width: '20%',
        },
        {
          name: 'Nam_Faculty',
          title: 'Facultad',
          width: '20%',
        },
        {
          name: 'Nam_Program',
          title: 'Programa académico',
          width: '20%',
        },
        {
          name: '__slot:status',
          title: 'Curso solicitado',
          dataClass: 'text-left',
          width: '10%',
        },
      ],
      DLDataList: [],
      refNoData: false,
      caseModel: [],
      formUpdate: [],
      renderComponent1: false,
      renderComponent2: false,
    }
  },
  components: {
    DataList,
  },
  methods: {
    loadListCases () {
      let loader = this.$loading.show()
      var casesData = IberoHelpers.getCasedata(this.$store, 7, 1)
      casesData.then(Response => {
        if (Response.data) {
          this.DLDataList = Response.data
          this.FilterData.ListPrograms = IberoHelpers.uniqueBy(
            Response.data,
            'Nam_Program'
          )
          this.FilterData.ListFaculty = IberoHelpers.uniqueBy(
            Response.data,
            'Nam_Faculty'
          )
          IberoHelpers.forceRerender1(this)
        } else {
          this.refNoData = true
        }
        loader.hide()
      })
    },
  },
  created: function () {
    this.loadListCases()
  },
}
</script>